import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(theme => ({
  wrapper: {
    padding: 15,
  },
  title: {
    color: theme.palette.primary.main,
    textAlign: 'center',
    marginBottom: 20
  },
  subtitle: {
    color: 'grey',
    fontSize: 14
  },
  field: {
    marginBottom: 15
  },
  newPasswordInvalidMessage: {
    color: 'darkred',
    marginBottom: 10,
  },
  submit: {
    marginTop: 10,
    marginBottom: 15
  },
  signUpLinkWrapper: {
    marginTop: 5,
    marginBottom: 8,
    textAlign: 'center',
  },
  signUpLink: {
    color: '#003475',
    fontWeight: 'bold',
    fontSize: 14,
    transition: 'color 300ms ease',
    '&:hover': {
      color: theme.palette.primary.main,
    }
  },
  forgotPasswordLink: {
    color: 'grey',
    fontSize: 14,
    transition: 'color 300ms ease',
    '&:hover': {
      color: theme.palette.primary.main,
    }
  }
}))
